import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

const BrakePopup = () => {
  const wardrobeHeight = reactLocalStorage.getObject('wardrobeHeight');
  return wardrobeHeight === 218 ? (
    <p>
      Hamulec drzwi przesuwnych jest opcją obowiązkową w przypadku co najmniej jednego skrzydła
      drzwi wykonanego w większości ze szkła.
    </p>
  ) : (
    <p>
      Hamulec drzwi przesuwnych jest opcją obowiązkową w przypadku co najmniej jednego skrzydła
      drzwi wykonanego całkowicie ze szkła.
    </p>
  );
};

export default BrakePopup;
